import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
export default {
  name: 'Language',
  data: function data() {
    return {
      isOpen: true
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentLocale: 'i18n/locale',
    locales: 'i18n/locales'
  }), {
    position: function position() {
      return this.isOpen ? 'haut' : 'bas';
    },
    otherLocales: function otherLocales() {
      var _this = this;

      return this.locales.filter(function (l) {
        return l.market !== _this.currentLocale.market || l.language !== _this.currentLocale.language;
      });
    }
  }),
  mounted: function mounted() {
    this.isOpen = false;
  },
  methods: {
    changeLocale: function changeLocale(locale) {
      if (locale.market === 'US') {
        return 'https://us.maisonsdumonde.com/';
      }

      return "/".concat(locale.market, "/").concat(locale.language);
    }
  }
};